import React, {Component} from "react";
import HeaderComponent from "../components/HeaderComponent";

export class Header extends Component{
    render(){
        return(
            <HeaderComponent />
        )
    }
}

export default Header;